// Actions

import axios from "axios";
import __popperHandler from "./popperHandler";

let actionHandlers = {

    getSelectedRows: function(table) {
        if (!table) {
            table = document.querySelector('.table');
        }
        return Array.from(table.querySelectorAll('.table-items .table-checkbox input[type="checkbox"]:checked')).map(_ => _.value);
    },

    removeItem: function(container) {

        let title = choicesTranslate('Kaydı silmek istediğinize emin misiniz?');

        let itemTitle = document.querySelector('meta[name="la:item:title"]');
        if (itemTitle) {
            title = choicesTranslate("{item} kaydını silmek istediğinize emin misiniz?", { item: itemTitle.getAttribute('content')  });
        }

        __popperHandler.confirm({
            title: title,
            body: choicesTranslate('Veriler silindikten sonra geri getirilemeyecektir.'),
            confirm: {
                label: choicesTranslate('Sil'),
                class: 'button--red',
                handler: function() {
                    let destroyForm = document.querySelector('.form-destroy-item');
                    if (destroyForm) {
                        destroyForm.submit();
                    }
                    container.classList.remove('actions--active');
                    return true;
                },
            },
            cancel: {
                label: choicesTranslate('Vazgeç'),
                class: 'button--gray',
                handler: function() {
                    container.classList.remove('actions--active');
                    return true;
                }
            },
        });
    },

    removeOrder: function(container) {
        __popperHandler.confirm({
            title: 'Bu siparişi silmek istediğinize emin misiniz?',
            body: 'Eğer sipariş tamamlandıysa ve doktor referansı ile komisyon hesaplandıysa, sipariş doktorun komisyon listesinde gözkümeyebilir.',
            confirm: {
                label: 'Sil',
                class: 'button--red',
                handler: function() {
                    let destroyForm = document.querySelector('.form-destroy-item');
                    if (destroyForm) {
                        destroyForm.submit();
                    }
                    container.classList.remove('actions--active');
                    return true;
                },
            },
            cancel: {
                label: 'Vazgeç',
                class: 'button--gray',
                handler: function() {
                    container.classList.remove('actions--active');
                    return true;
                }
            },
        });
    },

    approvePayment: function(container) {
        __popperHandler.confirm({
            title: 'Sipariş ödemesi onaylansın mı?',
            body: 'Genellikle Havale / EFT seçilen ve askıda (ödeme bekleyen) siparişin durumunu "Onaylandı" olarak güncellemek için kullanılır.\n\nDevam etmek istiyor musunuz?',
            confirm: {
                label: 'Ödemeyi Onayla',
                class: 'button--blue',
                handler: function() {

                    let editForm = document.querySelector('form[method="POST"]').getAttribute('action');
                    axios.post(editForm, {
                        '_method': 'PUT',
                        'status': 'approved'
                    });

                    document.querySelector('[name="status"]').value = "approved";
                    document.querySelector('[name="status"]').dispatchEvent(new Event('change'));

                    container.classList.remove('actions--active');
                    return true;
                },
            },
            cancel: {
                label: 'Vazgeç',
                class: 'button--gray',
                handler: function() {
                    container.classList.remove('actions--active');
                    return true;
                }
            },
        });
    },

    removeApplicant: function(container) {
        __popperHandler.confirm({
            title: 'Katılımcıyı silmek istediğinize emin misiniz?',
            body: 'Bu katılımcının yapmış olduğu tüm başvurular geri getirilemeyecek şekilde silinecektir.',
            confirm: {
                label: 'Sil',
                class: 'button--red',
                handler: function() {
                    let destroyForm = document.querySelector('.form-destroy-item');
                    if (destroyForm) {
                        destroyForm.submit();
                    }
                    container.classList.remove('actions--active');
                    return true;
                },
            },
            cancel: {
                label: 'Vazgeç',
                class: 'button--gray',
                handler: function() {
                    container.classList.remove('actions--active');
                    return true;
                }
            },
        });
    },


    approveApplication: function(container) {
        __popperHandler.confirm({
            title: 'Başvuruyu onaylamak istediğinize emin misiniz?',
            body: 'Başvuru onaylandıktan sonra başvuranı ödeme sayfasına yönlendirecek bir e-posta gönderilecektir.<br/><br/>İşlemden sonra eğer uygunsa bir sonraki başvuru formuna geçilecektir.',
            confirm: {
                label: 'Onayla ve devam et',
                class: 'button--primary',
                handler: function() {
                    return true;
                },
            },
            cancel: {
                label: 'Vazgeç',
                class: 'button--gray',
                handler: function() {
                    container.classList.remove('actions--active');
                    return true;
                }
            },
        });
    },

    rejectApplication: function(container) {
        __popperHandler.confirm({
            title: 'Başvuruyu reddetmek istediğinize emin misiniz?',
            body: 'Başvuru reddedildikten sonra başvurana bir bilgi e-postası gönderilecektir.<br/><br/>İşlemden sonra eğer uygunsa bir sonraki başvuru formuna geçilecektir.',
            confirm: {
                label: 'Reddet ve devam et',
                class: 'button--red',
                handler: function() {
                    return true;
                },
            },
            cancel: {
                label: 'Vazgeç',
                class: 'button--gray',
                handler: function() {
                    container.classList.remove('actions--active');
                    return true;
                }
            },
        });
    },

    exportAll: function() {
        let target = location.pathname.replace(/\/*$/, '') + '/export';
        let link = document.createElement('a');
        link.setAttribute('href', target);
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener');
        document.body.appendChild(link);
        link.click();
    },

    exportSearched: function() {
        let target = location.pathname.replace(/\/*$/, '') + '/export?' + location.search.replace(/^\?/, '');
        let link = document.createElement('a');
        link.setAttribute('href', target);
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener');
        document.body.appendChild(link);
        link.click();
    },

    exportSelected: function() {
        let target = location.pathname.replace(/\/*$/, '') + '/export?i=' + actionHandlers.getSelectedRows().join(',');
        let link = document.createElement('a');
        link.setAttribute('href', target);
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener');
        document.body.appendChild(link);
        link.click();
    }
};

let displayHandlers = {

    canExport: function() {
        let tag = document.querySelector('meta[name="la:item:exportable"]');
        return tag && tag.getAttribute('content') == '1';
    },

    hasSelected: function() {
        return actionHandlers.getSelectedRows().length;
    },

    exportSelected: function() {
        return displayHandlers.canExport() && displayHandlers.hasSelected();
    },

    exportSearched: function() {
        let query = document.querySelector('meta[name="la:item:query"]');
        let filter = document.querySelector('meta[name^="la:item:filter:"]');
        let found = document.querySelector('meta[name="la:item:found"]');
        return displayHandlers.canExport() && (query || filter) && found && parseInt(found.getAttribute('content')) > 0;
    }

};

let options = {
    'item-actions': [
        {
            'label': choicesTranslate('Kaydı Sil'),
            'handler': actionHandlers.removeItem,
            'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19.32 9.46s-.55 6.73-.86 9.572c-.15 1.35-.99 2.14-2.36 2.17 -2.61.04-5.23.05-7.83-.01 -1.319-.03-2.15-.84-2.29-2.17 -.32-2.87-.86-9.579-.86-9.579"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20.7 6.23H3.74"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.44 6.23c-.79 0-1.47-.56-1.62-1.33l-.25-1.22c-.15-.57-.66-.95-1.237-.95h-4.24c-.58 0-1.09.38-1.24.94l-.25 1.21c-.16.76-.83 1.32-1.62 1.32"></path></svg>',
            'color': 'red',
        },
    ],
    'order-actions': [
        {
            'label': 'Ödemeyi Onayla',
            'handler': actionHandlers.approvePayment,
            'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.33 2.75H7.66c-3.021 0-4.92 2.13-4.92 5.166v8.16c0 3.02 1.88 5.166 4.91 5.166h8.66c3.03 0 4.91-2.14 4.91-5.166V7.9c0-3.03-1.89-5.17-4.92-5.17Z"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.43 12l2.37 2.37 4.746-4.75"></path></svg>',
        },
        {
            'separator': true,
        },
        {
            'label': 'Siparişi Sil',
            'handler': actionHandlers.removeOrder,
            'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19.32 9.46s-.55 6.73-.86 9.572c-.15 1.35-.99 2.14-2.36 2.17 -2.61.04-5.23.05-7.83-.01 -1.319-.03-2.15-.84-2.29-2.17 -.32-2.87-.86-9.579-.86-9.579"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20.7 6.23H3.74"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.44 6.23c-.79 0-1.47-.56-1.62-1.33l-.25-1.22c-.15-.57-.66-.95-1.237-.95h-4.24c-.58 0-1.09.38-1.24.94l-.25 1.21c-.16.76-.83 1.32-1.62 1.32"></path></svg>',
            'color': 'red',
        }
    ],
    'applicant-actions': [
        {
            'separator': true,
        },
        {
            'label': 'Başvuruyu Reddet',
            'handler': actionHandlers.removeOrder,
            'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19.32 9.46s-.55 6.73-.86 9.572c-.15 1.35-.99 2.14-2.36 2.17 -2.61.04-5.23.05-7.83-.01 -1.319-.03-2.15-.84-2.29-2.17 -.32-2.87-.86-9.579-.86-9.579"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20.7 6.23H3.74"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.44 6.23c-.79 0-1.47-.56-1.62-1.33l-.25-1.22c-.15-.57-.66-.95-1.237-.95h-4.24c-.58 0-1.09.38-1.24.94l-.25 1.21c-.16.76-.83 1.32-1.62 1.32"></path></svg>',
            'color': 'red',
        }
    ],
    'application-actions': [
        {
            'label': 'Başvuruyu Onayla',
            'handler': actionHandlers.approveApplication,
            'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2c0 4.97-4.03 9-9 9 -4.98 0-9-4.03-9-9 0-4.98 4.02-9 9-9 4.97 0 9 4.02 9 9Z"></path></svg>',
            'color': 'green',
        },
        {
            'separator': true,
        },
        {
            'label': 'Başvuruyu Reddet',
            'handler': actionHandlers.rejectApplication,
            'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" fill-rule="evenodd" d="M13.47 14.89c-.99.69-2.19 1.1-3.48 1.1 -3.32 0-6-2.69-6-6 0-1.3.41-2.5 1.1-3.48l8.36 8.36Zm1.41-1.42L6.51 5.1c.98-.7 2.18-1.11 3.47-1.11 3.31 0 6 2.68 6 6 0 1.29-.42 2.49-1.11 3.47Zm3.1-3.48c0 4.41-3.59 8-8 8 -4.42 0-8-3.59-8-8 0-4.42 3.58-8 8-8 4.41 0 8 3.58 8 8Z"></path></svg>',
            'color': 'red',
        }
    ],
    'listing-actions': [
        {
            'label': 'Tümünü Dışa Aktar',
            'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.71 16.22H8.49"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.71 12.03H8.49"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11.25 7.86H8.49"></path><path fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.9 2.74s-7.68 0-7.689 0c-2.76.01-4.47 1.83-4.47 4.603v9.19c-.001 2.78 1.72 4.6 4.506 4.6 0 0 7.676-.01 7.689-.01 2.76-.02 4.47-1.84 4.47-4.61v-9.2c0-2.784-1.73-4.61-4.51-4.61Z"></path></svg>',
            'handler': actionHandlers.exportAll,
            'display': displayHandlers.canExport,
        },
        {
            'label': 'Aramayı Dışa Aktar',
            'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11.76 2.77a8.98 8.98 0 1 0 0 17.97 8.98 8.98 0 1 0 0-17.98Z"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18.01 18.48l3.52 3.51"></path></svg>',
            'handler': actionHandlers.exportSearched,
            'display': displayHandlers.exportSearched,
        },
        {
            'label': 'Seçilenleri Dışa Aktar',
            'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.33 2.75H7.66c-3.021 0-4.92 2.13-4.92 5.166v8.16c0 3.02 1.88 5.166 4.91 5.166h8.66c3.03 0 4.91-2.14 4.91-5.166V7.9c0-3.03-1.89-5.17-4.92-5.17Z"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.43 12l2.37 2.37 4.746-4.75"></path></svg>',
            'handler': actionHandlers.exportSelected,
            'display': displayHandlers.exportSelected,
        }
    ]
}


function choicesTranslate(keyword, replacements = {}) {
    let lang = document.querySelector("html").getAttribute("lang");
    if (lang === null) lang = "tr";

    const translations = {
        tr: {
            "Kaydı Sil": "Kaydı Sil",
            "Kaydı silmek istediğinize emin misiniz?": "Kaydı silmek istediğinize emin misiniz?",
            "Veriler silindikten sonra geri getirilemeyecektir.": "Veriler silindikten sonra geri getirilemeyecektir.",
            "Sil": "Sil",
            "Vazgeç": "Vazgeç",
            "{item} kaydını silmek istediğinize emin misiniz?": "{item} kaydını silmek istediğinize emin misiniz?",
        },
        en: {
            "Kaydı Sil": "Delete Application",
            "Kaydı silmek istediğinize emin misiniz?": "Are you sure you want to delete the application?",
            "Veriler silindikten sonra geri getirilemeyecektir.": "Data cannot be recovered after deletion.",
            "Sil": "Delete",
            "Vazgeç": "Cancel",
            "{item} kaydını silmek istediğinize emin misiniz?": "Are you sure you want to delete the {item} record?",
        },
    };

    let translation = translations[lang][keyword] || keyword;

    for (const [key, value] of Object.entries(replacements)) {
        translation = translation.replace(new RegExp(`{${key}}`, 'g'), value);
    }

    return translation;
}


Array.from(document.querySelectorAll('.actions')).forEach(function(container) {

    let actionButton = container.querySelector('[data-options]');

    if (!actionButton) {
        return;
    }

    let itemOptions = actionButton.getAttribute('data-options');

    if (options[itemOptions]) {

        let optionsElement = document.createElement('div');
        optionsElement.className = 'actions-body';
        optionsElement.setAttribute('tabindex', '0');
        actionButton.setAttribute('tabindex', '0');
        container.setAttribute('tabindex', '0');

        let optionsItems = document.createElement('div');
        optionsItems.className = 'actions-items';

        let dynamicItems = [];

        for (let i = 0; i < options[itemOptions].length; i++) {

            let option = options[itemOptions][i];

            let label = option.label ? option.label : false;
            let shortcut = option.shortcut ? option.shortcut : false;
            let icon = option.icon ? option.icon : false;
            let color = option.color ? option.color : false;
            let hasHandler = typeof option.handler == 'function';
            let displayHandler = typeof option.display == 'function' ? option.display : false;

            let isSeparator = undefined !== option.separator ? option.separator : false;

            let optionItem = document.createElement('div');

            optionItem.className = 'actions-item';

            if (isSeparator) {
                optionItem.classList.add('actions-item--separator');
            } else {

                if (color) {
                    optionItem.classList.add('actions-item--' + color);
                }

                let itemOutput = ``;

                if (icon) {
                    itemOutput += `<span class="actions-item-icon">${icon}</span>`;
                }

                if (label) {
                    itemOutput += `<p class="actions-item-label">${label}</p>`;
                }

                if (shortcut) {
                    itemOutput += `<span class="actions-item-shortcut">${shortcut}</span>`;
                }

                optionItem.innerHTML = itemOutput;
                if (hasHandler) {
                    optionItem.onclick = function() {
                        return option['handler'](optionsElement);
                    }
                }
            }

            if (displayHandler) {
                dynamicItems.push({
                    element: optionItem,
                    callback: displayHandler
                });
            }

            optionsItems.appendChild(optionItem);

        }

        optionsElement.appendChild(optionsItems);

        document.body.appendChild(optionsElement);


        actionButton.onclick = function() {

            let isHidden = optionsElement.className.indexOf('actions--active') === -1;

            optionsElement.classList.toggle('actions--active', isHidden);
            actionButton.classList.toggle('button--active', isHidden);

            for (let i = 0; i < dynamicItems.length; i++) {
                let item = dynamicItems[i];
                let response = item['callback'].apply(item['element']);
                item['element'].classList.toggle('actions-item--hide', !response);
            }

            if (isHidden) {
                optionsElement.focus();
                positionTo(optionsElement, actionButton);
            }

            return false;
        }

        optionsElement.onfocusout = function(event) {
            if (!event.relatedTarget || (event.relatedTarget && event.relatedTarget.closest('.actions') !== container)) {
                optionsElement.classList.remove('actions--active');
                actionButton.classList.remove('button--active');
            }
        }

    }

});

function positionTo(source, target, offset) {

      offset = offset || false;

      if (!offset) {
          offset = {
              x: 0,
              y: 0,
          };
      } else if(parseFloat(offset)) {
        let xy = parseFloat(offset);
        offset = {
            x: xy,
            y: xy,
        };
      } else {
          offset = {
              x: offset.x || 0,
              y: offset.y || 0
          };
      }

      let yOffset = window.yOffset || (document.documentElement.clientHeight) ? document.documentElement.scrollTop : document.body.scrollTop;

      let targetRect = target.getBoundingClientRect();
      let sourceRect = source.getBoundingClientRect();

      let newY = 10 + yOffset + targetRect.y + targetRect.height + offset.y;
      let newX = (targetRect.x + targetRect.width) - (sourceRect.width + offset.x);

      if (newY + sourceRect.height >= yOffset + document.documentElement.clientHeight) {
          newY = yOffset + (targetRect.y - sourceRect.height - 10 - offset.y);
      }


      source.style.left = newX + "px";
      source.style.top = newY + "px";

  }
